/** @format */

import algoliasearch from 'algoliasearch/lite';

export const SEARCH_CLIENT = algoliasearch(
  'UY1649EYWB',
  '336b687129d4045d68b767159898555f'
);

export const INDEX_NAME = `crawler_varian_fullvarian-full`;

export const QUERY_SUGGESTIONS = `crawler_varian_fullvarian-full_query_suggestions`;

export const HIERARCHICAL_ATTRIBUTES = ['primaryCategory', 'secondaryCategory'];
